import { DoBootstrap, Injector, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { TabBtnElement } from './tab-btn.component';
import { createCustomElement } from '@angular/elements';
import { TranslocoModule } from '@jsverse/transloco';

@NgModule({
    declarations: [TabBtnElement],
    imports: [CommonModule, RouterModule, TranslocoModule],
    exports: [TabBtnElement],
})
export class TabBtnModule implements DoBootstrap {
    constructor(private injector: Injector) {}

    ngDoBootstrap(): void {
        const el = createCustomElement(TabBtnElement, {
            injector: this.injector,
        });

        customElements.define('bazis-tab-btn', el);
    }
}
